export const ERRORS__POP = 'ERRORS__POP';
export const ERRORS__PUSH = 'ERRORS__PUSH';
export const ERRORS__REMOVE = 'ERRORS__REMOVE';
